import { useMemo } from 'react'

import { Drawer, DrawerProps } from '@hhgtech/hhg-components'
import { useIntl } from 'react-intl'

import { WeekOfPregnancyApi } from 'interfaces/types'

import { StyledWeekOption } from './index.styled'

type WeekDrawerProps = {
  dueDateAllWeeks: Array<WeekOfPregnancyApi>
  firstDay: Date
  currentWeek: number
  onWeekClick(value: string): void
} & DrawerProps
export const WeekDrawer = ({
  dueDateAllWeeks,
  open,
  onClose,
  firstDay,
  currentWeek,
  onWeekClick,
  ...rest
}: WeekDrawerProps) => {
  const { formatMessage: f } = useIntl()
  const pregnancyWeekSelectOptions = useMemo(() => {
    return Array.from({ length: 44 }).map((_, index) => {
      return {
        value: String(index + 1),
        fruitIcon: dueDateAllWeeks[index]?.fruit_icon,
        firstDay,
        label: f(
          {
            id: 'dueDateTool.weekNumber',
            defaultMessage: 'Week {weekNumber}',
          },
          {
            weekNumber: index + 1,
          },
        ),
      }
    })
  }, [firstDay, dueDateAllWeeks])
  return (
    <Drawer
      title={f(
        { id: 'childCard.age.week', defaultMessage: '{weeks} weeks' },
        { weeks: 40 },
      )}
      onClose={onClose}
      open={open}
      placement="bottom"
      {...rest}
    >
      <div>
        {pregnancyWeekSelectOptions.map((w) => (
          <StyledWeekOption
            key={w.value}
            isSelected={w.value === String(currentWeek)}
            onClick={() => {
              onWeekClick(w.value)
              onClose()
            }}
            {...w}
          />
        ))}
      </div>
    </Drawer>
  )
}
